export const ACCESS_TOKEN_KEY = 'access-token';
export const CUSTOMER_ACCESS_TOKEN_KEY = 'customer-access-token';
export const RESEND_CODE = 'resendCode';
export const ADMIN_REDIRECT_URL_KEY = 'adminRedirectUrl';
export const CUSTOMER_REDIRECT_URL_KEY = 'customerRedirectUrl';
